import React from 'react';

import Icon from '../Icon';
import TranslationProvider from '../../providers/TranslationProvider';
import ErrorSvg from '../../svg/icons/error.svg';
import './RSVP.scss';

export default function RSVPDeclined() {
  return (
    <div className="ResyInviteRsvpDecline__head">
      <div className="ResyInviteRsvpDecline__icon">
        <Icon className="ResyIcon" iconClass="ResyIcon" component={ErrorSvg} aria-hidden="true" />
      </div>
      <TranslationProvider
        translationKey="invite_declined_header"
      >
        <h2 className="ResyInviteRsvpDecline__title">
          Invite Declined
        </h2>
      </TranslationProvider>

      <hr />

      <div className="ResyInviteRsvpDecline__blurb">
        <TranslationProvider
          translationKey="invite_declined_body"
        >
          <span>
            Please
            {' '}
            <a href="mailto:help@resy.com">email us</a>
            {' '}
            if you have questions.
          </span>
        </TranslationProvider>
      </div>
    </div>
  );
}

RSVPDeclined.displayName = 'RSVPDeclined';
